import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getCallForImpact } from 'modules/callForImpact/actions';
import CallForImpact from '../components';

function mapStateToProps(state) {
  return {
    callForImpact: state.callForImpact.callForImpact,
    callForImpactStatus: state.callForImpact.callForImpactStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCallForImpact: bindActionCreators(getCallForImpact, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CallForImpact));



// WEBPACK FOOTER //
// ./src/routes/CallForImpact/container/index.js